import { FLEETIO_ACCOUNT_LINKING_FLAG } from '~/common/models/featureFlags.model';
import { GmfProviderAccountStatus } from '~/common/models/gmf.model';

import { PARTNER_DEFAULTS } from '../defaults';
import { ENROLLMENT_VIEWS, PARTNER_IDS, type PartnerConfig } from '../types';

const DATA_SHARED_KEYS = {
  vin: 'integrations:account.manage.dataShared.vin',
  odometer: 'integrations:account.manage.dataShared.odometer',
} as const;

export const fleetioConfig: PartnerConfig = {
  id: PARTNER_IDS.FLEETIO,
  providerCode: 'FLEET_IO',
  flag: FLEETIO_ACCOUNT_LINKING_FLAG,
  nameKey: 'integrations:fleetio.name',
  descriptionKey: 'integrations:fleetio.description',
  shop: {
    counts: [
      {
        key: ENROLLMENT_VIEWS.ELIGIBLE,
        labelKey: 'integrations:fleetio.eligibleToLink',
        tooltipKey: 'integrations:fleetio.eligibilityTooltip',
      },
      {
        key: ENROLLMENT_VIEWS.ENROLLED,
        labelKey: 'integrations:fleetio.enrolled',
      },
    ],
    // GMF admin linking already established the account; the card only shows once that's active.
    isVisible: ({ gmfLink }) =>
      gmfLink?.status === GmfProviderAccountStatus.ACTIVE,
  },
  manage: {
    ...PARTNER_DEFAULTS.manage,
    enrollmentTiles: [ENROLLMENT_VIEWS.ENROLLED, ENROLLMENT_VIEWS.ERRORS],
    dataSharedRows: [
      { key: 'vin', labelKey: DATA_SHARED_KEYS.vin },
      { key: 'odometer', labelKey: DATA_SHARED_KEYS.odometer },
    ],
  },
};
